@if (assistant.busyElsewhere()) {
  <p role="status" class="text-text-secondary m-0 flex items-center gap-1.5 text-xs">
    <i
      aria-hidden="true"
      class="text-text-tertiary animate-spin motion-reduce:animate-none"
      [class]="ICONS.circleNotch"></i>
    {{ 'assistant.busy.status' | translate }}
  </p>
} @else if (assistant.contextSummary(); as summary) {
  <div class="text-text-primary flex min-w-0 items-center gap-1.5 text-xs font-medium">
    <i
      aria-hidden="true"
      class="text-accent-main shrink-0"
      [class]="icons[summary.kind]"></i>
    <app-assistant-context-text [summary]="summary" />
    <button
      #info
      type="button"
      class="text-text-tertiary hover:text-text-secondary inline-flex shrink-0 cursor-pointer rounded-xs transition-colors"
      [attr.aria-label]="details().label">
      <i aria-hidden="true" [class]="ICONS.info"></i>
    </button>
    <app-tooltip
      [target]="info"
      [title]="'assistant.context.tooltip_title' | translate"
      [content]="details().html"
      [position]="'top'"
      [maxWidth]="260" />
  </div>
}
